module.exports = __webpack_public_path__ + "img/ssbg10.c99d9055.jpg";